module.exports = __webpack_public_path__ + "static/media/event_repeat_black_24dp.cae068e5.svg";